import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import 'swiper/css/autoplay';
import { useMediaQuery } from "react-responsive";
import { Autoplay } from "swiper/modules";

function generateRandomClassName() {
    const randomString = Math.random().toString(36).substring(2, 8); // Génère une chaîne aléatoire
    return `pagemarques-caroussel-swiper-${randomString}`;
  }

  
export default function Caroussel({
    data,
    count = 10,
    per_lines = 5,
    gap = 16,
    tablet_per_lines = 3,
    mobile_per_lines = 3,
    speed = 1500,
    ease = false
}) {
    const isTablet = useMediaQuery({ query: '(max-width: 800px)' });
    const isMobile = useMediaQuery({ query: '(max-width: 500px)' });

    function getPerLines() {
        if (isMobile) {
            return mobile_per_lines;
        } else if (isTablet) {
            return tablet_per_lines;
        } else {
            return per_lines;
        }
    }

    async function getBrands() {
        const baseBrands = [];
        let page = 1;
        const available_brands_ids = [...data.data.all_brands].map(({ id }) => id);
        while (baseBrands.length < count) {
            const url = `https://data.catalogues-pharmagency.fr/api/brands?limit=10&page=${page}`;
            try {
                const response = await axios.get(url);
                if (response.data.data.length > 0) {
                    response.data.data.forEach((data) => {
                        if (available_brands_ids.includes(data.id) && baseBrands.length < count) {
                            baseBrands.push(data);
                        }
                    });
                    page++;
                } else {
                    break;
                }
            } catch (err) {
                console.log(err);
                break;
            }
        }
        setBrands(baseBrands);
    }

    const [brands, setBrands] = useState([]);
    const [currentPerLines, setCurrentPerLines] = useState(getPerLines());

    useEffect(() => {
        getBrands();
    }, []);

    useEffect(() => {
        setCurrentPerLines(getPerLines());
    }, [isMobile, isTablet]);

    const randomClassName = generateRandomClassName();

    return (
        <>
          {!ease && (
            <style jsx>{`
                .${randomClassName} .swiper-wrapper {
                    transition-timing-function: linear !important; // Applique une transition linéaire aux slides
                }
            `}</style>
          )}
          {brands.length > 0 &&
          <Swiper
          modules={[Autoplay]}
          slidesPerView={currentPerLines}
          loop={true}
          loopedSlides={brands.length} // Important pour un effet fluide en mode loop
          spaceBetween={gap}
          speed={speed} // Contrôle la vitesse de défilement (en millisecondes)
          autoplay={{
            delay: 0, // Pas de délai entre les slides
            disableOnInteraction: false,
          }}
          className={randomClassName}
          allowTouchMove={false}
        >
          {brands.map((brand, index) => (
            <SwiperSlide key={index}>
              <div>
                <img
                  src={brand.png_url ? brand.png_url : brand.jpg_url}
                  alt={brand.name}
                  className="w-full aspect-square object-contain"
                />
              </div>
            </SwiperSlide>
          ))}
          </Swiper>}
        </>
      );
      
}
